<script>
    export let message = "";
    export let toast = {};
  </script>
  
  <div class="toast-content">
    <div class="toast-left">
      {#if toast.image}
        <img class="toast-image" src={toast.image} alt="Toast">
      {/if}
    </div>
    <div class="toast-right">
      <span>{message}</span>
      {#if toast.text_button && toast.url_button}
        <a class="toast-button" style="color: {toast.text_color}" href="{toast.url_button}" target="{toast.window === 1 ? '_blank':'_self'}">
          {toast.text_button}
        </a>
      {/if}
      <div class="toast-bar" style="background: {toast.bar_color}; animation-duration: {toast.duration}ms;"></div>
    </div>
  </div>